module.exports = __webpack_public_path__ + "onboarding-environments-2.932e8a6c69c778b05e99792bab0f984c.hashedasset.svg";